import criteria from '../../data/skinAnalysisCriteria.json';
import { extractMetrics } from './metrics';
import { ruleEvaluate } from './ruleEvaluator';
import { webllmSupported, webllmEvaluate } from './webllmEvaluator';

export { criteria };

// In-browser WebLLM is OFF by default: on a small (1B) model it's slow (big
// model download + in-browser inference), unreliable (emits invalid JSON that
// fails to parse), and non-deterministic (conflicts with repeatable results).
// The deterministic rule engine drives findings + recommendations instead.
// Flip this to true to experiment with the LLM path again (ideally with a
// larger/grammar-constrained model or a hosted backend behind this same seam).
const USE_WEBLLM = false;

// The SkinAnalyzer contract. Input: the wizard captures + intake answers.
// Output: { findings, summary, engine, metrics, forward }. A hosted model could
// later implement this same shape with zero UI change.
export async function analyze({ captures, intake, onProgress } = {}) {
  const forward = captures && captures.forward;
  if (!forward || !forward.canvas) {
    return {
      findings: [],
      summary: 'No photo was captured — please try the analysis again.',
      engine: 'none',
      metrics: {},
      forward: forward || null,
    };
  }

  // Region centroids: 468-pt mesh if present, else mapped within the detected
  // face box, else the whole frame.
  const keypoints = forward.pose && forward.pose.keypoints;
  const box = forward.pose && forward.pose.box;
  const { metrics, positions } = extractMetrics(forward.canvas, keypoints, box);

  if (USE_WEBLLM && webllmSupported()) {
    try {
      const out = await webllmEvaluate(metrics, criteria, intake, onProgress, positions);
      if (out && Array.isArray(out.findings) && out.findings.length) {
        return { ...out, metrics, forward };
      }
    } catch (err) {
      console.warn('analyze: WebLLM evaluation failed; using rule engine', err);
    }
  }

  return { ...ruleEvaluate(metrics, criteria, positions, intake), metrics, forward };
}
